/**
 * SHARED
 * Cross-cutting code usable by any module. Must not import from any module.
 */

import { useEffect, useState } from "react";
import { isPlatformAdmin } from "../utils/ticketService.js";

// Is the signed-in user Brand Command staff? `checked` flips true once known,
// so callers can avoid flashing admin UI before the answer arrives.
export function usePlatformAdmin() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [checked, setChecked] = useState(false);
  useEffect(() => {
    let alive = true;
    isPlatformAdmin().then((v) => {
      if (alive) { setIsAdmin(v); setChecked(true); }
    });
    return () => { alive = false; };
  }, []);
  return { isAdmin, checked };
}
